var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApp2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dropbox"
  }, /*#__PURE__*/React.createElement("path", {
    id: "back",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z",
    fill: "#2E2882"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 10.0105L19.058 6.5L15.25 9.64006L20.7371 12.9874L24.5 10.0105ZM11.442 6.50003L6.00004 10.0105L9.76289 12.9874L6 15.9647L11.442 19.4752L15.25 16.335L19.0579 19.4752L24.4999 15.9647L20.7372 12.9875L15.2499 16.3349L9.76295 12.9875L15.2499 9.64009L11.442 6.50003ZM11.4421 20.1415L15.2612 17.0105L19.0803 20.1415L20.7146 19.0873V20.2691L15.2612 23.5L9.80774 20.2691V19.0873L11.4421 20.1415Z",
    fill: "#FEB0A5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp2);
export default __webpack_public_path__ + "static/media/app2.a5ebc4b3e28f2e509e3972dc8e1160ba.svg";
export { ForwardRef as ReactComponent };